import { cn } from '@/lib/utils';
import { SIGNAL_META } from '@/lib/scoring';
import type { SignalState } from '@/lib/types';

export function SignalBadge({
  state,
  className,
}: {
  state: SignalState;
  className?: string;
}) {
  const meta = SIGNAL_META[state];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider',
        meta.className,
        className,
      )}
    >
      <span>{meta.emoji}</span>
      {meta.label}
    </span>
  );
}
